import { Stack, useMediaQuery, useTheme } from '@mui/material';

import { Icon, Mask, Typography } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { Wrapper, Value, Label, IconWrapper, Image } from './styles';
import type { ValuesProps } from './types';

export const Values = ({
  title,
  image,
  imageAlt,
  totalPaid,
  totalRemaining,
}: ValuesProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Wrapper
      gap={3}
      direction="column"
      alignItems="flex-start"
      justifyContent="space-around"
    >
      <Stack
        gap={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
      >
        {image && <Image src={image} alt={imageAlt} />}

        <Typography fontWeight={900} fontSize={16}>
          {title}
        </Typography>
      </Stack>
      <Stack width="100%" direction={isMobile ? 'column' : 'row'}>
        <Stack gap={2} direction="row" width="100%">
          <IconWrapper>
            <Icon
              name="actions-b2b-attach-money"
              color={NEW_COLORS.SEMANTICS.SUCCESS[500]}
            />
          </IconWrapper>
          <Stack spacing={0.5} direction="column" width="100%">
            <Value color={NEW_COLORS.SEMANTICS.SUCCESS[500]}>
              {Mask.currency(totalPaid)}
            </Value>
            <Label>Total pago</Label>
          </Stack>
        </Stack>
        <Stack gap={2} direction="row" width="100%">
          <IconWrapper color="red">
            <Icon
              name="actions-b2b-error-circle"
              color={NEW_COLORS.SEMANTICS.ERROR[500]}
            />
          </IconWrapper>
          <Stack spacing={0.5} direction="column" width="100%">
            <Value color={NEW_COLORS.SEMANTICS.ERROR[500]}>
              {Mask.currency(totalRemaining)}
            </Value>
            <Label>Total em aberto</Label>
          </Stack>
        </Stack>
      </Stack>
    </Wrapper>
  );
};
